

export const BasePlanName = (plansArray, baseplanId) => {
    if (!plansArray || !baseplanId) return "";

    for (const plan of plansArray) {

        if (plan._id === baseplanId) {
            return plan.name;
        }

    }

    return "";
};



export function resolvePlanAndSubplan(membership, allData) {
    console.log("984867membership, allData", membership, allData)
    let planId = membership._id || membership;
    let subplanId;


    if (membership?.archived) {
        // 1. Try matching with active base plan
        let activePlan = allData.find((p) => p.oldplanid === membership._id);
        console.log("activePlan", activePlan);

        if (activePlan) {
            if (activePlan.subplans?.length > 0) {
                // Use the first subplan as the default
                planId = activePlan._id;           // parent plan
                subplanId = activePlan.subplans[0]._id; // first subplan
            } else {
                // No subplans, treat activePlan itself as subplan
                planId = activePlan.baseplan || activePlan._id; // fallback to baseplan if exists
                subplanId = activePlan._id;
            }
        } else {
            // 2. Check all subplans for oldplanid match
            for (const plan of allData) {
                const matchedSub = plan.subplans?.find(
                    (sp) => sp.oldplanid === membership._id
                );
                if (matchedSub) {
                    planId = plan._id;          // parent plan
                    subplanId = matchedSub._id; // matched subplan
                    break;
                }
            }
        }
    } else if (membership.isVariation) {
        console.log("variation case", membership.baseplan, membership._id);
        planId = membership.baseplan;
        subplanId = membership._id;
    }

    console.log("resolved planId and subplanId", planId, subplanId);
    return { planId, subplanId };
}
